// extracted by mini-css-extract-plugin
module.exports = {"main_content":"main_content-LcrEruCc"};